module.exports = __webpack_public_path__ + "images/icons/icon-cart-d4e020dc.svg";